import { render, staticRenderFns } from "./StoreLocatorConfigFloatingButton.vue?vue&type=template&id=54c85d6c&scoped=true&"
import script from "./StoreLocatorConfigFloatingButton.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigFloatingButton.vue?vue&type=style&index=0&id=54c85d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c85d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
